import { render, staticRenderFns } from "./MonthlyEIS.vue?vue&type=template&id=206a452e&scoped=true"
import script from "./MonthlyEIS.vue?vue&type=script&lang=js"
export * from "./MonthlyEIS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206a452e",
  null
  
)

export default component.exports